export const OAUTH_POPUP_NAME = 'youcan-oauth';
export const OAUTH_CALLBACK_PATH = '/oauth/callback';
export const OAUTH_MESSAGE_TYPE = 'OAUTH_CALLBACK';

const OAUTH_STATE = /^[a-f0-9]{64}:[a-z0-9_-]+(?::[A-Za-z0-9_-]+)?$/i;

export interface OAuthReturn {
  code: string | null;
  state: string;
  error: string | null;
  errorDescription: string | null;
  integrationKey: string | null;
}

export function readOAuthReturn(search: string): OAuthReturn | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const state = params.get('state');
  const code = params.get('code');
  const error = params.get('error');
  if (!state || !OAUTH_STATE.test(state)) return null;
  if (!code && !error) return null;
  const integrationFromState = state.split(':')[1] || '';
  return {
    code,
    state,
    error,
    errorDescription: params.get('error_description'),
    integrationKey: params.get('integration') || integrationFromState || null
  };
}

export function isOAuthCallbackPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === OAUTH_CALLBACK_PATH;
}

export function isOAuthReturnLocation(
  loc: { search?: string } = typeof window !== 'undefined' ? window.location : { search: '' }
): boolean {
  return readOAuthReturn(loc.search || '') !== null;
}

/** Popup ouvert par window.open(url, OAUTH_POPUP_NAME). Le nom survit au détour chez YouCan. */
export function isOAuthPopup(): boolean {
  return typeof window !== 'undefined' && window.name === OAUTH_POPUP_NAME;
}
